<template>
  <div class="picker-list">
    <PickerItem
      v-for="team in items"
      :key="team.id"
      :name="team.teamName"
      :avatarUrl="team.avatar && team.avatar.avatar ? team.avatar.avatar.thumb : ''"
      :selected="modelTeamIndex(team) > -1"
      @changed="onChanged($event, team)"
    />
  </div>
</template>
<script>
import PickerItem from '@/components/PickerItem.vue';

export default {
  props: {
    items: Array,
    value: Array,
  },
  mounted() {
    console.log(this.items);
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    onChanged(value, team) {
      if (value && this.modelTeamIndex(team) < 0) {
        this.model.push(team);
      } else if (!value && this.modelTeamIndex(team) > -1) {
        this.model.splice(this.modelTeamIndex(team), 1);
      }
    },
    modelTeamIndex(searchTeam) {
      let found = -1;
      this.model.forEach((team, index) => {
        if (parseInt(team.id, 10) === parseInt(searchTeam.id, 10)) {
          found = index;
        }
      });
      return found;
    },
  },
  watch: {
    model() {
      console.log(this.model);
    },
  },
  components: {
    PickerItem,
  },
};
</script>
<style lang="scss" scoped>
.picker-list {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  overflow: auto;
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02) !important;
  max-height: 300px;
}
</style>
